import React, {Fragment} from 'react';
import {Redirect, Route, Switch, withRouter} from "react-router-dom";
import Sidebar from "../components/Sidebar";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import Preloader from "../components/Preloader";
const BaseTemplateIntranet = (props) => {

    return (
            <>

                <Sidebar />

        <main className="content">
          <Navbar />
                    {
                        props.children
                    }
          <Footer  />
        </main>
    </>

    )

};

export default withRouter(BaseTemplateIntranet);
